module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/chiba_funabashi_point2_1-fc7aff03727069da733105d3628c90bc.jpg";